import React from 'react';
import { motion } from 'framer-motion';
import { Block, Link, Heading, Paragraph, Strong } from '../../devlink/_Builtin';
import { MortgageResult } from '../types/mortgage';

interface ResultsScreenProps {
  result: MortgageResult;
  onReset: () => void;
}

const ResultsScreen: React.FC<ResultsScreenProps> = ({ result, onReset }) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      maximumFractionDigits: 0,
    }).format(amount);
  };

  return (
    <Block>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        {result.approved ? (
          <div>
            <Heading tag="h1">Congratulations!</Heading>
            <Paragraph>
              Based on your information, you may be eligible for a mortgage of up to:
            </Paragraph>
            <div>
              {formatCurrency(result.maxLoanAmount!)}
            </div>
            
            <div>
              <div>
                <span>Estimated Monthly Payment:</span>
                <Strong>{formatCurrency(result.monthlyPayment!)}</Strong>
              </div>
              <div>
                <span>Maximum Loan Amount:</span>
                <Strong>{formatCurrency(result.maxLoanAmount!)}</Strong>
              </div>
            </div>

            {result.contactDetails && (
              <div>
                <Heading tag="h3">Speak to a Mortgage Advisor</Heading>
                <Paragraph>Ready to take the next step? Our experienced mortgage advisors are here to help you through the process.</Paragraph>
                
                <div>
                  <div>
                    <Strong>Phone:</Strong> {result.contactDetails.phone}
                  </div>
                  <div>
                    <Strong>Email:</Strong> {result.contactDetails.email}
                  </div>
                  <div>
                    <Strong>Advisor:</Strong> {result.contactDetails.advisorName}
                  </div>
                </div>
              </div>
            )}

            <div>
              <Paragraph>
                <Strong>Important:</Strong> This is an estimate based on the information you provided. 
                Final mortgage approval is subject to a full assessment of your financial circumstances, 
                credit history, and property valuation. Terms and conditions apply.
              </Paragraph>
            </div>
          </div>
        ) : (
          <div>
            <Heading tag="h1">Application Assessment</Heading>
            <Paragraph>
              Unfortunately, based on the information provided, we are unable to offer you a mortgage at this time.
            </Paragraph>
            
            <div>
              <Strong>Reason:</Strong> {result.rejectionReason}
            </div>

            <div>
              <Heading tag="h3">What you can do next:</Heading>
              <ul>
                <li>Review your income and expenses to improve your financial profile</li>
                <li>Consider reducing existing debts or monthly commitments</li>
                <li>Speak to a mortgage advisor for personalized advice</li>
                <li>Check your credit score and take steps to improve it if needed</li>
              </ul>
            </div>

            <div>
              <Heading tag="h3">Get Professional Advice</Heading>
              <Paragraph>Our mortgage advisors can help you understand your options and work towards mortgage approval.</Paragraph>
              
              <div>
                <div>
                  <Strong>Phone:</Strong> 0800 123 4567
                </div>
                <div>
                  <Strong>Email:</Strong> advice@example.com
                </div>
              </div>
            </div>
          </div>
        )}

        <div>
          <Link
            button={true}
            onClick={onReset}
          >
            Start New Calculation
          </Link>
        </div>
      </motion.div>
    </Block>
  );
};

export default ResultsScreen; 